function sortByDate(array) {
  array.sort((a, b) => {
    let fa = a.date, fb = b.date;
    if (fa > fb) return -1;
    if (fa < fb) return 1;
    return 0;
  });
}

export default sortByDate;